/**
 * Generated by orval v8.12.1 🍺
 * Do not edit manually.
 * Verdi Dashboard API
 * API for the Verdi Dashboard application
 * OpenAPI spec version: 1.0.0
 */

import type {
	DataTag,
	DefinedInitialDataOptions,
	DefinedUseQueryResult,
	MutationFunction,
	QueryClient,
	QueryFunction,
	QueryKey,
	UndefinedInitialDataOptions,
	UseMutationOptions,
	UseMutationResult,
	UseQueryOptions,
	UseQueryResult,
} from "@tanstack/react-query";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { customFetch } from "../custom-fetch";
import type {
	AreaOfInterest,
	AreaOfInterestCreate,
	AreaOfInterestUpdate,
	CreateAOI400,
	CreateAOI500,
	DeleteAOI400,
	DeleteAOI404,
	DeleteAOI500,
	GetAOI400,
	GetAOI404,
	GetAOI500,
	ListAOIs400,
	ListAOIs500,
	UpdateAOI400,
	UpdateAOI404,
	UpdateAOI500,
} from "./schemas";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const getGetAOIUrl = (aoiId: string) => {
	return `/aois/${aoiId}`;
};

/**
 * @summary Get a single Area of Interest by ID
 */
export const getAOI = async (
	aoiId: string,
	options?: RequestInit,
): Promise<AreaOfInterest> => {
	return customFetch<AreaOfInterest>(getGetAOIUrl(aoiId), {
		...options,
		method: "GET",
	});
};

export const getGetAOIQueryKey = (aoiId: string) => {
	return ["aois", aoiId] as const;
};

export const getGetAOIQueryOptions = <
	TData = Awaited<ReturnType<typeof getAOI>>,
	TError = GetAOI400 | GetAOI404 | GetAOI500,
>(
	aoiId: string,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getAOI>>, TError, TData>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getGetAOIQueryKey(aoiId);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof getAOI>>> = ({
		signal,
	}) => getAOI(aoiId, { signal, ...requestOptions });

	return {
		queryKey,
		queryFn,
		enabled: aoiId !== null && aoiId !== undefined,
		...queryOptions,
	} as UseQueryOptions<Awaited<ReturnType<typeof getAOI>>, TError, TData> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};
};

export type GetAOIQueryResult = NonNullable<Awaited<ReturnType<typeof getAOI>>>;
export type GetAOIQueryError = GetAOI400 | GetAOI404 | GetAOI500;

export function useGetAOI<
	TData = Awaited<ReturnType<typeof getAOI>>,
	TError = GetAOI400 | GetAOI404 | GetAOI500,
>(
	aoiId: string,
	options: {
		query: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getAOI>>, TError, TData>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof getAOI>>,
					TError,
					Awaited<ReturnType<typeof getAOI>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAOI<
	TData = Awaited<ReturnType<typeof getAOI>>,
	TError = GetAOI400 | GetAOI404 | GetAOI500,
>(
	aoiId: string,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getAOI>>, TError, TData>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof getAOI>>,
					TError,
					Awaited<ReturnType<typeof getAOI>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAOI<
	TData = Awaited<ReturnType<typeof getAOI>>,
	TError = GetAOI400 | GetAOI404 | GetAOI500,
>(
	aoiId: string,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getAOI>>, TError, TData>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get a single Area of Interest by ID
 */

export function useGetAOI<
	TData = Awaited<ReturnType<typeof getAOI>>,
	TError = GetAOI400 | GetAOI404 | GetAOI500,
>(
	aoiId: string,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getAOI>>, TError, TData>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
} {
	const queryOptions = getGetAOIQueryOptions(aoiId, options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> };

	return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get a single Area of Interest by ID
 */
export const useSetGetAOIQueryData = () => {
	const queryClient = useQueryClient();
	return (
		aoiId: string,
		updater:
			| Awaited<ReturnType<typeof getAOI>>
			| undefined
			| ((
					old: Awaited<ReturnType<typeof getAOI>> | undefined,
			  ) => Awaited<ReturnType<typeof getAOI>> | undefined),
	) => {
		queryClient.setQueriesData<Awaited<ReturnType<typeof getAOI>>>(
			{ queryKey: getGetAOIQueryKey(aoiId) },
			updater,
		);
	};
};

/**
 * @summary Get a single Area of Interest by ID
 */
export const useGetGetAOIQueryData = () => {
	const queryClient = useQueryClient();
	return (aoiId: string) =>
		queryClient.getQueryData<Awaited<ReturnType<typeof getAOI>>>(
			getGetAOIQueryKey(aoiId),
		);
};

export const getUpdateAOIUrl = (aoiId: string) => {
	return `/aois/${aoiId}`;
};

/**
 * @summary Update an existing Area of Interest
 */
export const updateAOI = async (
	aoiId: string,
	areaOfInterestUpdate: AreaOfInterestUpdate,
	options?: RequestInit,
): Promise<AreaOfInterest> => {
	return customFetch<AreaOfInterest>(getUpdateAOIUrl(aoiId), {
		...options,
		method: "PATCH",
		headers: { "Content-Type": "application/json", ...options?.headers },
		body: JSON.stringify(areaOfInterestUpdate),
	});
};

export const getUpdateAOIMutationOptions = <
	TError = UpdateAOI400 | UpdateAOI404 | UpdateAOI500,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof updateAOI>>,
		TError,
		{ aoiId: string; data: AreaOfInterestUpdate },
		TContext
	>;
	request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof updateAOI>>,
	TError,
	{ aoiId: string; data: AreaOfInterestUpdate },
	TContext
> => {
	const mutationKey = ["updateAOI"];
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation &&
			"mutationKey" in options.mutation &&
			options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof updateAOI>>,
		{ aoiId: string; data: AreaOfInterestUpdate }
	> = (props) => {
		const { aoiId, data } = props ?? {};

		return updateAOI(aoiId, data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type UpdateAOIMutationResult = NonNullable<
	Awaited<ReturnType<typeof updateAOI>>
>;
export type UpdateAOIMutationBody = AreaOfInterestUpdate;
export type UpdateAOIMutationError = UpdateAOI400 | UpdateAOI404 | UpdateAOI500;

/**
 * @summary Update an existing Area of Interest
 */
export const useUpdateAOI = <
	TError = UpdateAOI400 | UpdateAOI404 | UpdateAOI500,
	TContext = unknown,
>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof updateAOI>>,
			TError,
			{ aoiId: string; data: AreaOfInterestUpdate },
			TContext
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseMutationResult<
	Awaited<ReturnType<typeof updateAOI>>,
	TError,
	{ aoiId: string; data: AreaOfInterestUpdate },
	TContext
> => {
	return useMutation(getUpdateAOIMutationOptions(options), queryClient);
};
export const getDeleteAOIUrl = (aoiId: string) => {
	return `/aois/${aoiId}`;
};

/**
 * @summary Delete an existing Area of Interest
 */
export const deleteAOI = async (
	aoiId: string,
	options?: RequestInit,
): Promise<AreaOfInterest> => {
	return customFetch<AreaOfInterest>(getDeleteAOIUrl(aoiId), {
		...options,
		method: "DELETE",
	});
};

export const getDeleteAOIMutationOptions = <
	TError = DeleteAOI400 | DeleteAOI404 | DeleteAOI500,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof deleteAOI>>,
		TError,
		{ aoiId: string },
		TContext
	>;
	request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof deleteAOI>>,
	TError,
	{ aoiId: string },
	TContext
> => {
	const mutationKey = ["deleteAOI"];
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation &&
			"mutationKey" in options.mutation &&
			options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof deleteAOI>>,
		{ aoiId: string }
	> = (props) => {
		const { aoiId } = props ?? {};

		return deleteAOI(aoiId, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type DeleteAOIMutationResult = NonNullable<
	Awaited<ReturnType<typeof deleteAOI>>
>;

export type DeleteAOIMutationError = DeleteAOI400 | DeleteAOI404 | DeleteAOI500;

/**
 * @summary Delete an existing Area of Interest
 */
export const useDeleteAOI = <
	TError = DeleteAOI400 | DeleteAOI404 | DeleteAOI500,
	TContext = unknown,
>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof deleteAOI>>,
			TError,
			{ aoiId: string },
			TContext
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseMutationResult<
	Awaited<ReturnType<typeof deleteAOI>>,
	TError,
	{ aoiId: string },
	TContext
> => {
	return useMutation(getDeleteAOIMutationOptions(options), queryClient);
};
export const getListAOIsUrl = () => {
	return `/aois`;
};

/**
 * @summary List all Areas of Interest
 */
export const listAOIs = async (
	options?: RequestInit,
): Promise<AreaOfInterest[]> => {
	return customFetch<AreaOfInterest[]>(getListAOIsUrl(), {
		...options,
		method: "GET",
	});
};

export const getListAOIsQueryKey = () => {
	return ["aois"] as const;
};

export const getListAOIsQueryOptions = <
	TData = Awaited<ReturnType<typeof listAOIs>>,
	TError = ListAOIs400 | ListAOIs500,
>(options?: {
	query?: Partial<
		UseQueryOptions<Awaited<ReturnType<typeof listAOIs>>, TError, TData>
	>;
	request?: SecondParameter<typeof customFetch>;
}) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getListAOIsQueryKey();

	const queryFn: QueryFunction<Awaited<ReturnType<typeof listAOIs>>> = ({
		signal,
	}) => listAOIs({ signal, ...requestOptions });

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof listAOIs>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListAOIsQueryResult = NonNullable<
	Awaited<ReturnType<typeof listAOIs>>
>;
export type ListAOIsQueryError = ListAOIs400 | ListAOIs500;

export function useListAOIs<
	TData = Awaited<ReturnType<typeof listAOIs>>,
	TError = ListAOIs400 | ListAOIs500,
>(
	options: {
		query: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof listAOIs>>, TError, TData>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof listAOIs>>,
					TError,
					Awaited<ReturnType<typeof listAOIs>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListAOIs<
	TData = Awaited<ReturnType<typeof listAOIs>>,
	TError = ListAOIs400 | ListAOIs500,
>(
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof listAOIs>>, TError, TData>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof listAOIs>>,
					TError,
					Awaited<ReturnType<typeof listAOIs>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListAOIs<
	TData = Awaited<ReturnType<typeof listAOIs>>,
	TError = ListAOIs400 | ListAOIs500,
>(
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof listAOIs>>, TError, TData>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List all Areas of Interest
 */

export function useListAOIs<
	TData = Awaited<ReturnType<typeof listAOIs>>,
	TError = ListAOIs400 | ListAOIs500,
>(
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof listAOIs>>, TError, TData>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
} {
	const queryOptions = getListAOIsQueryOptions(options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> };

	return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List all Areas of Interest
 */
export const useSetListAOIsQueryData = () => {
	const queryClient = useQueryClient();
	return (
		updater:
			| Awaited<ReturnType<typeof listAOIs>>
			| undefined
			| ((
					old: Awaited<ReturnType<typeof listAOIs>> | undefined,
			  ) => Awaited<ReturnType<typeof listAOIs>> | undefined),
	) => {
		queryClient.setQueriesData<Awaited<ReturnType<typeof listAOIs>>>(
			{ queryKey: getListAOIsQueryKey() },
			updater,
		);
	};
};

/**
 * @summary List all Areas of Interest
 */
export const useGetListAOIsQueryData = () => {
	const queryClient = useQueryClient();
	return () =>
		queryClient.getQueryData<Awaited<ReturnType<typeof listAOIs>>>(
			getListAOIsQueryKey(),
		);
};

export const getCreateAOIUrl = () => {
	return `/aois`;
};

/**
 * @summary Create a new Area of Interest
 */
export const createAOI = async (
	areaOfInterestCreate: AreaOfInterestCreate,
	options?: RequestInit,
): Promise<AreaOfInterest> => {
	return customFetch<AreaOfInterest>(getCreateAOIUrl(), {
		...options,
		method: "POST",
		headers: { "Content-Type": "application/json", ...options?.headers },
		body: JSON.stringify(areaOfInterestCreate),
	});
};

export const getCreateAOIMutationOptions = <
	TError = CreateAOI400 | CreateAOI500,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof createAOI>>,
		TError,
		{ data: AreaOfInterestCreate },
		TContext
	>;
	request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof createAOI>>,
	TError,
	{ data: AreaOfInterestCreate },
	TContext
> => {
	const mutationKey = ["createAOI"];
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation &&
			"mutationKey" in options.mutation &&
			options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof createAOI>>,
		{ data: AreaOfInterestCreate }
	> = (props) => {
		const { data } = props ?? {};

		return createAOI(data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type CreateAOIMutationResult = NonNullable<
	Awaited<ReturnType<typeof createAOI>>
>;
export type CreateAOIMutationBody = AreaOfInterestCreate;
export type CreateAOIMutationError = CreateAOI400 | CreateAOI500;

/**
 * @summary Create a new Area of Interest
 */
export const useCreateAOI = <
	TError = CreateAOI400 | CreateAOI500,
	TContext = unknown,
>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof createAOI>>,
			TError,
			{ data: AreaOfInterestCreate },
			TContext
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseMutationResult<
	Awaited<ReturnType<typeof createAOI>>,
	TError,
	{ data: AreaOfInterestCreate },
	TContext
> => {
	return useMutation(getCreateAOIMutationOptions(options), queryClient);
};
